import React from 'react';
import { clsx } from '@components/Provider';
import { Box, makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';

interface PurchaseOrderViewInfoEntryProps {
  label: string;
  data: React.ReactNode | string;
  className?: string;
}

const PurchaseOrderViewInfoEntry: React.FC<PurchaseOrderViewInfoEntryProps> = ({
  label,
  data,
  className
}) => {
  const { infoBox } = useDocumentsViewInfoEntryStyles();

  return (
    <Box className={clsx([infoBox, className])}>
      <CustomizedTypography
        variant="body1"
        color="textSecondary"
        className="label"
      >
        {label}
      </CustomizedTypography>
      {React.isValidElement(data) ? (
        data
      ) : (
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          className="pre-line"
        >
          {data}
        </CustomizedTypography>
      )}
    </Box>
  );
};

export default PurchaseOrderViewInfoEntry;

const useDocumentsViewInfoEntryStyles = makeStyles((theme) => ({
  infoBox: {
    display: 'flex',
    gap: '8px',
    '& .label': {
      minWidth: '80px'
    }
  }
}));
